// The api returns `{"error": "<code>"}` on endpoints written to the current
// contract and `{"message": "..."}` on older paths (XPEN-3362).
export const readApiErrorCode = (error) => {
    const body = error?.response?.data;
    if (!body || typeof body !== "object") {
        return null;
    }
    const code = body.error || body.message;
    return typeof code === "string" && code ? code : null;
};

// Generic key for when the api said nothing usable. Nested, so a bare
// "unknown_error" would not resolve.
export const UNKNOWN_ERROR_KEY = "errors.unknown_error";
